import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import {
    initTelegram, isTelegramAvailable, showBackButton,
    hideBackButton, setBackButtonHandler, clearBackButtonHandler, getInitData
} from './utils/telegram';
import StoresPage from './pages/StoresPage';
import CatalogPage from './pages/CatalogPage/CatalogPage';
import CartPage from './pages/CartPage/CartPage';
import OrderSetupPage from './pages/OrderPages/OrderSetupPage';
import OrderSubmitPage from './pages/OrderPages/OrderSubmitPage';
import PaymentPage from './pages/PaymentPage';
import OrderSuccessPage from './pages/OrderPages/OrderSuccessPage';
import LoginPage from './pages/LoginPage';
import './App.css';
import { useAuth } from "./utils/AuthContext";
import authUser from "./utils/auth";


//Когда не выбирал магазин, а сразу в корзину, то ошибка с объектом магазина
const App = () => {
    const { authenticateUser } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const init = async () => {
            try {
                if (isTelegramAvailable()) {
                    initTelegram();

                    const initData = getInitData();
                    console.log("Init Data:", initData);

                    /*if (!initData) {
                        navigate('/login');
                        return;
                    }*/

                    console.log('Authenticating user...');
                    const res = await authenticateUser(initData);
                    if (!res) {
                        console.error('User not authenticated');
                        throw new Error('User not authenticated');
                    }
                } else {
                    console.warn("Telegram WebApp SDK недоступен");
                }
            } catch (error) {
                console.error("Authentication error:", error);
                //navigate('/login');
            }
        };

        init()
            .then(() => console.log("Telegram WebApp initialized"))
            .catch((error) => console.error("Failed to initialize Telegram WebApp:", error));
    }, []);

    useEffect(() => {
        const isHomePage = location.pathname === '/';

        if (isHomePage) {
            hideBackButton();
            clearBackButtonHandler();
        } else {
            showBackButton();
            setBackButtonHandler(() => navigate(-1));
        }

        return () => {
            clearBackButtonHandler();
            hideBackButton();
        };
    }, [location.pathname, navigate]);

    return (
        <Routes>
            <Route path="/" element={<StoresPage />} />
            <Route path="/catalog/:storeId" element={<CatalogPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/order-setup" element={<OrderSetupPage />} />
            <Route path="/order-submit" element={<OrderSubmitPage />} />
            <Route path="/order-success" element={<OrderSuccessPage />} />
            <Route path="/login" element={<LoginPage />} />
        </Routes>
    );
};

export default App;